import { rateLimitApi } from '../../apis';
import { RateLimitBucket } from './RateLimiterConfig';

export const getRateLimitConfig = () => {
  return rateLimitApi.getRateLimitConfig();
};

export const updateDefaultRateLimit = (limit: number) => {
  return rateLimitApi.updateDefaultRateLimit({ defaultRateLimitSeconds: limit });
};

export const updateRateLimitBucket = (bucket: RateLimitBucket) => {
  return rateLimitApi.updateRateLimitBucket({
    internalApiRateLimitBucket: {
      bucketName: bucket.bucketName,
      limitPerSecond: bucket.limitPerSecond,
      endpoints: bucket.endpoints,
    },
  });
};

export const deleteRateLimitBucket = (bucketName: string) => {
  return rateLimitApi.deleteRateLimitBucket({ bucketName });
};
